import { Routes } from '@angular/router';

import CatalogShellComponent from './shell.component';

const routes: Routes = [
    {
        path: '',
        component: CatalogShellComponent,
        children: [
            {
                path: '',
                pathMatch: 'full',
                loadComponent: () => import('@stair-craft/catalog/list'),
                data: {
                    seoTitle: $localize`:@@seoCatalogTitle:Каталог материалов — GoldenCalc`,
                    seoDescription: $localize`:@@seoCatalogDesc:Породы дерева, покрытия, ограждения и подсветка для онлайн-конструктора лестниц GoldenCalc.`,
                },
            },
            {
                path: ':slug',
                loadComponent: () => import('@stair-craft/catalog/item'),
                data: {
                    seoTitle: $localize`:@@seoCatalogItemTitle:Материал — GoldenCalc`,
                    seoDescription: $localize`:@@seoCatalogItemDesc:Характеристики материала и возможность сразу использовать его в конструкторе лестниц.`,
                    // Страница материала пока заглушка без описания: в индексе она была бы пустышкой.
                    seoNoindex: true,
                },
            },
        ],
    },
];

export default routes;
